// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Employee  {
    _originalTypeClassName = "Loom.BO.Employee";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Employee.translate = translateService;
}
this.ProjectsMemberships = [];
this.EmploymentContracts = [];
this.LeaveApprovers = [];
this.LeaveBalances = [];
this.Id = null;
this.Active = false;
this.AccountingCode = null;
this.EmployeeAndOrg = null;
this.EmployeeCode = null;
this.StartDate = null;
this.EndDate = null;
this.Tmp_TotalCostsForPeriod = null;
this.Tmp_DailyRateForPeriod = null;
this.CalculatedHourlyRate = null;
this.YearUsedForRateCalculation = null;
this.CalculatedDailyRate = null;
this.TotalAnnualCost = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Active:any;
AccountingCode:any;
EmployeeAndOrg:any;
EmployeeCode:any;
StartDate:any;
EndDate:any;
Tmp_TotalCostsForPeriod:any;
Tmp_DailyRateForPeriod:any;
CalculatedHourlyRate:any;
YearUsedForRateCalculation:any;
CalculatedDailyRate:any;
TotalAnnualCost:any;
ProjectsMemberships:any;
Person:any;
Organisation:any;
EmploymentContracts:any;
LeaveApprovers:any;
LeaveBalances:any;
static setProjectsMemberships = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectsMemberships == null) $this.ProjectsMemberships = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectsMemberships.length > 0) {
                    Domain.Employee.removeProjectsMemberships($this, $this.ProjectsMemberships[0]);
                }

                Domain.Employee.addManyProjectsMemberships($this, copyItems);
            }
static addManyProjectsMemberships = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addProjectsMemberships($this, items[i]);
                }
            }
static addProjectsMemberships = ($this, item) => {
                if ($this.ProjectsMemberships == null) $this.ProjectsMemberships = [];
                if (item == null || $this.ProjectsMemberships.indexOf(item) > -1) return;
                $this.ProjectsMemberships.push(item);
if (item.Employee != $this) {
Domain.ProjectTeamMember.setEmployee(item, $this);
}
}
static addRangeProjectsMemberships = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addProjectsMemberships($this, item));
            }
static removeProjectsMemberships = ($this, item) => {
                if ($this == null || $this.ProjectsMemberships == null || $this.ProjectsMemberships.indexOf(item) === -1) return;
                var _index = $this.ProjectsMemberships.indexOf(item);
                $this.ProjectsMemberships.splice(_index, 1);
item.Employee = null;
}
static clearProjectsMemberships = ($this) => { $this.ProjectsMemberships = null; }
static setPerson = ($this, value) => {
var oldValue = $this.Person;
$this.Person = value;
if (value != null) {
if (oldValue != null) {
Domain.Person.removeEmploymentRelationships(oldValue, $this);
}
Domain.Person.addEmploymentRelationships(value, $this);
}
}
static setOrganisation = ($this, value) => {
var oldValue = $this.Organisation;
$this.Organisation = value;
if (value != null) {
if (oldValue != null) {
Domain.Organisation.removeEmploymentRelationships(oldValue, $this);
}
Domain.Organisation.addEmploymentRelationships(value, $this);
}
}
static setEmploymentContracts = ($this, items) => {
                if (items == null) items = [];
                if ($this.EmploymentContracts == null) $this.EmploymentContracts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EmploymentContracts.length > 0) {
                    Domain.Employee.removeEmploymentContracts($this, $this.EmploymentContracts[0]);
                }

                Domain.Employee.addManyEmploymentContracts($this, copyItems);
            }
static addManyEmploymentContracts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addEmploymentContracts($this, items[i]);
                }
            }
static addEmploymentContracts = ($this, item) => {
                if ($this.EmploymentContracts == null) $this.EmploymentContracts = [];
                if (item == null || $this.EmploymentContracts.indexOf(item) > -1) return;
                $this.EmploymentContracts.push(item);
if (item.Employee != $this) {
Domain.EmploymentContract.setEmployee(item, $this);
}
}
static addRangeEmploymentContracts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addEmploymentContracts($this, item));
            }
static removeEmploymentContracts = ($this, item) => {
                if ($this == null || $this.EmploymentContracts == null || $this.EmploymentContracts.indexOf(item) === -1) return;
                var _index = $this.EmploymentContracts.indexOf(item);
                $this.EmploymentContracts.splice(_index, 1);
item.Employee = null;
}
static clearEmploymentContracts = ($this) => { $this.EmploymentContracts = null; }
static setLeaveApprovers = ($this, items) => {
                if (items == null) items = [];
                if ($this.LeaveApprovers == null) $this.LeaveApprovers = [];

                const copyItems = Common.cloneObject(items);

                while ($this.LeaveApprovers.length > 0) {
                    Domain.Employee.removeLeaveApprovers($this, $this.LeaveApprovers[0]);
                }

                Domain.Employee.addManyLeaveApprovers($this, copyItems);
            }
static addManyLeaveApprovers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addLeaveApprovers($this, items[i]);
                }
            }
static addLeaveApprovers = ($this, item) => {
                if ($this.LeaveApprovers == null) $this.LeaveApprovers = [];
                if (item == null || $this.LeaveApprovers.indexOf(item) > -1) return;
                $this.LeaveApprovers.push(item);
Domain.Person.addApprovingLeavesFor(item, $this);
}
static addRangeLeaveApprovers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addLeaveApprovers($this, item));
            }
static removeLeaveApprovers = ($this, item) => {
                if ($this == null || $this.LeaveApprovers == null || $this.LeaveApprovers.indexOf(item) === -1) return;
                var _index = $this.LeaveApprovers.indexOf(item);
                $this.LeaveApprovers.splice(_index, 1);
Domain.Person.removeApprovingLeavesFor(item, $this);
}
static clearLeaveApprovers = ($this) => { $this.LeaveApprovers = null; }
static setLeaveBalances = ($this, items) => {
                if (items == null) items = [];
                if ($this.LeaveBalances == null) $this.LeaveBalances = [];

                const copyItems = Common.cloneObject(items);

                while ($this.LeaveBalances.length > 0) {
                    Domain.Employee.removeLeaveBalances($this, $this.LeaveBalances[0]);
                }

                Domain.Employee.addManyLeaveBalances($this, copyItems);
            }
static addManyLeaveBalances = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addLeaveBalances($this, items[i]);
                }
            }
static addLeaveBalances = ($this, item) => {
                if ($this.LeaveBalances == null) $this.LeaveBalances = [];
                if (item == null || $this.LeaveBalances.indexOf(item) > -1) return;
                $this.LeaveBalances.push(item);
if (item.Employee != $this) {
Domain.LeaveBalance.setEmployee(item, $this);
}
}
static addRangeLeaveBalances = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addLeaveBalances($this, item));
            }
static removeLeaveBalances = ($this, item) => {
                if ($this == null || $this.LeaveBalances == null || $this.LeaveBalances.indexOf(item) === -1) return;
                var _index = $this.LeaveBalances.indexOf(item);
                $this.LeaveBalances.splice(_index, 1);
item.Employee = null;
}
static clearLeaveBalances = ($this) => { $this.LeaveBalances = null; }

static GetActive($this: any): any{let today = moment().startOf('day').toDate();
let activeContract = $this?.EmploymentContracts?.linq?.any((a) => (new Date(a?.StartDate).getTime()) <= (new Date(today).getTime()) && (!((a?.EndDate != null)) || (new Date(today).getTime()) <= (new Date(a?.EndDate).getTime())));
return activeContract;
}
static GetActiveContractForDate($this: any, date: any,ecEmployeeCategoryCode: any): any{return Domain.Employee.GetContractOfEmployeeForDate($this, date, ecEmployeeCategoryCode);
}
static GetActiveContractsForDateRange($this: any, startDate: any,endDate: any): any{return Domain.Employee.GetContractsOfEmployeeForDateRange($this, startDate, endDate);
}
static GetContractOfEmployeeForDate(employee: any,date: any,ecEmployeeCategoryCode: any): any{if ((!((date != null)))) {throw Error("Supply a valid date!");}
date = new Date(new Date(date)?.setHours(0, 0, 0, 0));
let searchDate = Joove.Common.safeNumber(moment(date).year()) * Joove.Common.safeNumber(100) + Joove.Common.safeNumber((moment(date).month() + 1));
let activeContracts = employee?.EmploymentContracts?.linq?.where((a) => CLMS.Framework.Number.LessThanOrEqual(() => Joove.Common.safeNumber(moment(a.StartDate).year()) * Joove.Common.safeNumber(100) + Joove.Common.safeNumber((moment(a.StartDate).month() + 1)), () => searchDate) && (!((a?.EndDate != null)) || CLMS.Framework.Number.LessThanOrEqual(() => searchDate, () => Joove.Common.safeNumber(moment(a.EndDate).year()) * Joove.Common.safeNumber(100) + Joove.Common.safeNumber((moment(a.EndDate).month() + 1)))))?.toArray();
if ((!(CLMS.Framework.String.IsNullOrEmpty((ecEmployeeCategoryCode ?? '').trim())))) {activeContracts = activeContracts?.linq?.where((a) => a?.EmploymentType?.ECEmployeeCategory?.Code == ecEmployeeCategoryCode)?.toArray();}
if ((CLMS.Framework.Number.GreaterThan(() => activeContracts.length, () => 1))) {console.warn(CLMS.Framework.String.Format("Multiple (i.e. {2}) active contracts for Employee: {0} and Org: {1}! Selecting the latest one.", employee?.Person?.FullName, employee?.Organisation?.ShortName, activeContracts?.length));for (let _ic = 0; _ic < (activeContracts == null ? 0 : activeContracts.length); _ic++) {let c = activeContracts[_ic];console.warn(CLMS.Framework.String.Format("\t- Employee: {0} and Org: {1}, from: {2} to {3}", employee?.Person?.FullName, employee?.Organisation?.ShortName, CLMS.Framework.DateTime.ToString(c?.StartDate, "dd/MM/yyyy"), CLMS.Framework.DateTime.ToString(c?.EndDate, "dd/MM/yyyy")));}return activeContracts?.linq?.orderByDescending((a) => a?.StartDate)?.toArray()?.linq?.where()?.firstOrDefault(null);}
return activeContracts?.linq?.where()?.firstOrDefault(null);
}
static GetContractsOfEmployeeForDateRange(employee: any,startDate: any,endDate: any): any{if ((!((startDate != null)))) {throw Error("Supply a valid start date!");}
if ((!((endDate != null)))) {throw Error("Supply a valid end date!");}
startDate = new Date(new Date(startDate)?.setHours(0, 0, 0, 0));
endDate = new Date(new Date(endDate)?.setHours(0, 0, 0, 0));
if (((new Date(startDate).getTime()) > (new Date(endDate).getTime()))) {throw Error("Supply a valid date range!");}
let activeContracts = employee?.EmploymentContracts?.linq?.where((a) => (new Date(new Date(new Date(a?.StartDate)?.setHours(0, 0, 0, 0))).getTime()) <= (new Date(endDate).getTime()) && (!((a?.EndDate != null)) || (new Date(new Date(new Date(a?.EndDate)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(startDate).getTime())))?.toArray();
return activeContracts;
}
static GetEmployeeAndOrg($this: any): any{return $this?.Person?.FullName + " (" + $this?.Organisation?.ShortName + ")";
}
static GetEndDate($this: any): any{if ($this?.EmploymentContracts?.linq?.any((a) => !((a?.EndDate != null)))) {return null;}
let lastContract = $this?.EmploymentContracts?.linq?.where((a) => (a?.EndDate != null))?.toArray()?.linq?.orderByDescending((a) => new Date(new Date(a?.EndDate)?.setHours(0, 0, 0, 0)))?.toArray()?.linq?.where()?.firstOrDefault(null);
return new Date(new Date(lastContract?.EndDate)?.setHours(0, 0, 0, 0));
}
static GetStartDate($this: any): any{let firstContract = $this?.EmploymentContracts?.linq?.orderBy((a) => new Date(new Date(a?.StartDate)?.setHours(0, 0, 0, 0)))?.toArray()?.linq?.where()?.firstOrDefault(null);
return new Date(new Date(firstContract?.StartDate)?.setHours(0, 0, 0, 0));
}
static IsActiveForDateRange($this: any, from: any,to: any): any{from = new Date(new Date(from)?.setHours(0, 0, 0, 0));
to = new Date(new Date(to)?.setHours(0, 0, 0, 0));
let activeContracts = Domain.Employee.GetContractsOfEmployeeForDateRange($this, from, to);
return CLMS.Framework.Number.GreaterThan(() => activeContracts.length, () => 0);
}
static SeedLeaves($this: any, year: any,policies: any): any{if (CLMS.Framework.Number.LessThanOrEqual(() => year, () => 0)) {return;}
let lastYear = Joove.Common.safeNumber(year) - Joove.Common.safeNumber(1);
for (let _ipolicy = 0; _ipolicy < (policies == null ? 0 : policies.length); _ipolicy++) {let policy = policies[_ipolicy];let existing = $this?.LeaveBalances?.linq?.where((l) => CLMS.Framework.Number.Equal(() => l.Policy.Id, () => policy.Id) && CLMS.Framework.Number.Equal(() => l.Year, () => year))?.firstOrDefault(null);if (existing != null) {continue;}let prevYearConfig = $this?.LeaveBalances?.linq?.where((l) => CLMS.Framework.Number.Equal(() => l.Policy.Id, () => policy.Id) && CLMS.Framework.Number.Equal(() => l.Year, () => lastYear))?.firstOrDefault(null);let balance = new Domain.LeaveBalance();Domain.LeaveBalance.setPolicy(balance, policy);balance.Year = year;balance.CurrentYearQuota = ((prevYearConfig != null && CLMS.Framework.Number.GreaterThan(() => prevYearConfig.CurrentYearQuota, () => 0)) ? prevYearConfig?.CurrentYearQuota : policy?.MaxAllowableDays);if (prevYearConfig != null && policy?.Carryover && CLMS.Framework.Number.GreaterThan(() => prevYearConfig.RemainingDays, () => 0)) {balance.CarryoverQuota = parseInt((prevYearConfig?.RemainingDays) as any);}$this?.LeaveBalances?.add(balance);}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}